<template>
  <div class="min-h-full bg-surface-muted text-content" @mousedown="com_SetLastActivityTime">
    <router-view />
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useAdminCommon } from '@/composables/useAdminCommon'
import { initTheme } from '@/composables/useTheme'

const { com_SetLastActivityTime } = useAdminCommon()

onMounted(() => {
  initTheme()
})
</script>
